/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// globalSearch
// GLOBALSEARCH
const GLOBALSEARCH= createAsyncThunk(
  "globalSearch/globalSearch",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const globalSearchSlice = createSlice({
  name: "globalSearchSlice",
  initialState: {
    globalSearch: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfglobalSearch: (state) => {
        state.globalSearch.loading = false
        state.globalSearch.error = false
        state.globalSearch.data = []
        state.globalSearch.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GLOBALSEARCH.fulfilled, (state, action) => {
      state.globalSearch = {
        ...state.globalSearch,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GLOBALSEARCH.pending, (state, action) => {
      state.globalSearch = {
        ...state.globalSearch,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GLOBALSEARCH.rejected, (state, action) => {
      state.globalSearch = {
        ...state.globalSearch,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const globalSearchAction = {
    GLOBALSEARCH,
};

export { globalSearchAction };
export default globalSearchSlice.reducer;
export const {setInitialStateOfglobalSearch} = globalSearchSlice.actions